export default __webpack_public_path__ + "static/media/graph-1-large.2a39366e.png";